/**
 * loginDraft.ts
 * In-memory draft for the sign-in form. Keeps the typed email/password across
 * navigation (e.g. tapping "Create one" → Sign up → Back) so the user never
 * re-types. Cleared on successful sign-in.
 *
 * Backed by the shared `createDraftStore` factory (see utils/draftStore.ts):
 * module-level only — never written to disk; lives for the session/tab and is
 * dropped the moment login succeeds.
 */

import { createDraftStore } from '../../utils/draftStore';

export interface LoginDraft {
  email: string;
  password: string;
}

const store = createDraftStore<LoginDraft>();

export const getLoginDraft = store.get;
export const setLoginDraft = store.set;
export const clearLoginDraft = store.clear;
